import { getInstance } from "@/auth/";

export default (to, from, next) => {
  if (navigator.onLine) {
    // Getting current Auth Instance
    const authService = getInstance();

    // If Authservice is finished loading and is authenticated then get Token and Init Auth
    if (!authService.loading) {
      fn(authService.isAuthenticated, to);
    } else {
      // Else wait till finish loading and add a listener for "isAuthenticated"
      authService.$watch("loading", loading => {
        if (loading === false) {
          fn(authService.isAuthenticated, to);
        }
      });
    }
  } else {
    if (to.meta.offlineAvailability) {
      return next();
    } else {
      console.log("AUTH GUARD REDIRECT");
      next("/mobile-view/home");
    }
  }

  function fn(isAuthenticated, to) {
    if (isAuthenticated) {
      return next();
    } else if (
      !isAuthenticated &&
      !to.meta.offlineAvailability &&
      window.location.host != "192.168.4.100"
    ) {
      next("/login");
    } else {
      return next();
    }
  }
};
